import { CSRF_TOKEN } from "@pages/csrf";
import { useEffect, useRef, useState } from "react";

export type ThreadViewer = {
  first_name: string;
  last_name: string;
  full_name: string;
  uuid: string;
  updated_at: number;
};

type ThreadViewersResponse = {
  [threadId: string]: ThreadViewer[];
};

export function useThreadViewers(threadIds: string[]): ThreadViewersResponse {
  const [threadViewers, setThreadViewers] = useState<ThreadViewersResponse>({});
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const fetchViewers = async () => {
    try {
      const formData = new FormData();
      threadIds.forEach((id) => formData.append("thread_ids[]", id));

      const response = await fetch("/messages/viewers/", {
        method: "POST",
        headers: {
          "X-CSRFToken": CSRF_TOKEN,
        },
        credentials: "include",
        body: formData,
      });
      const data = await response.json();
      setThreadViewers(data.threads_viewers || {});
    } catch (error) {
      console.error("Failed to fetch thread viewers:", error);
    }
  };

  useEffect(() => {
    if (threadIds.length === 0) return;
    fetchViewers();
    intervalRef.current = setInterval(fetchViewers, 5000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [threadIds]);

  return threadViewers;
}
